(function (window) {
  'use strict';
  if (window.StackhouseUploadV2) return;

  var sessionPromise = null;
  var sessionSurface = '';
  var guestToken = '';
  var activeTransfers = {};
  // File identity keeps Retry on the same server asset and idempotency key.
  var recoveries = new WeakMap();
  var pagehideCleanupBound = false;
  var GUEST_STORAGE_KEY = 'stackhouse:guest-upload-token:v1';
  try { guestToken = window.localStorage.getItem(GUEST_STORAGE_KEY) || ''; } catch (_error) {}
  var PROCESSING_TIMEOUT_MS = 180 * 1000;
  var PREPARATION_TIMEOUT_MS = 900 * 1000;
  var STATUS_READ_RETRY_DELAYS = [500, 1000, 2000];
  var ADMISSION_RETRY_DELAYS = [500, 1000, 2000];
  var FILE_HEADER_BYTES = 4096;
  var UNSUPPORTED_FORMAT_MESSAGE = "We couldn't recognize this file as a supported JPEG, PNG, TIFF, or HEIC photo. Export it again in one of those formats. Renaming the file extension will not convert it.";

  function uploadError(errorCode, message) {
    var error = new Error(message);
    error.errorCode = errorCode;
    error.retryable = false;
    return error;
  }

  var warningQueue = Promise.resolve();
  var warningSequence = 0;

  function isSelectionCancelled(error) {
    return Boolean(error && error.errorCode === 'UPLOAD_SELECTION_CANCELLED');
  }

  function discardUploadPreview(row) {
    if (!row) return;
    row.querySelectorAll('img').forEach(function (image) {
      var url = String(image.src || '');
      if (url.indexOf('blob:') === 0) window.URL.revokeObjectURL(url);
    });
    row.remove();
  }

  function colorProfileWarning(value) {
    var candidates = [value, value && value.image_object];
    for (var index = 0; index < candidates.length; index += 1) {
      var candidate = candidates[index];
      if (candidate && candidate.warning_type === 'no_icc_profile'
        && typeof candidate.warning === 'string' && candidate.warning.trim()) return candidate;
    }
    return null;
  }

  function showColorProfileWarning(warning, fileName) {
    return new Promise(function (resolve, reject) {
      var document = window.document;
      if (!document || !document.body) {
        reject(uploadError('UPLOAD_WARNING_UNAVAILABLE', 'Refresh the page and choose your file again to review its color profile.'));
        return;
      }
      var previousFocus = document.activeElement;
      var dialog = document.createElement('dialog');
      var panel = document.createElement('div');
      var title = document.createElement('h2');
      var name = document.createElement('p');
      var message = document.createElement('p');
      var actions = document.createElement('div');
      var continueButton = document.createElement('button');
      var chooseButton = document.createElement('button');
      var id = 'stackhouse-color-profile-' + (++warningSequence);
      var finished = false;

      if (!document.getElementById('stackhouse-color-profile-style')) {
        var style = document.createElement('style');
        style.id = 'stackhouse-color-profile-style';
        style.textContent = '[data-stackhouse-color-profile-dialog]{position:fixed;inset:0;box-sizing:border-box;margin:0;padding:20px;width:100%;max-width:none;height:100%;height:100dvh;max-height:none;border:0;background:transparent;color:#252525;z-index:2147483647;text-align:left;font-family:inherit;}'
          + '[data-stackhouse-color-profile-dialog][open]{display:flex;align-items:center;justify-content:center;}'
          + '[data-stackhouse-color-profile-dialog]::backdrop{background:rgba(0,0,0,.55);}'
          + '[data-stackhouse-color-profile-dialog][data-fallback]{background:rgba(0,0,0,.55);}'
          + '.stackhouse-color-profile-panel{box-sizing:border-box;background:#fff;border:1px solid #ddd;border-radius:12px;padding:28px;width:100%;max-width:520px;max-height:100%;overflow:auto;box-shadow:0 12px 50px rgba(0,0,0,.2);}'
          + '.stackhouse-color-profile-panel h2{font-weight:600;font-family:inherit;font-size:24px;line-height:1.25;margin:0 0 12px;color:inherit;}'
          + '.stackhouse-color-profile-panel p{font-size:16px;line-height:1.55;margin:0 0 16px;color:inherit;overflow-wrap:anywhere;}'
          + '.stackhouse-color-profile-panel .stackhouse-color-profile-name{font-size:14px;color:#666;margin-bottom:12px;}'
          + '.stackhouse-color-profile-panel a{display:inline-block;font-size:15px;line-height:1.5;color:#252525;text-decoration:underline;text-underline-offset:3px;}'
          + '.stackhouse-color-profile-actions{display:flex;flex-wrap:wrap;gap:10px;margin-top:24px;}'
          + '.stackhouse-color-profile-actions button{box-sizing:border-box;flex:1 1 190px;min-height:48px;padding:12px 16px;border:1px solid #252525;border-radius:6px;background:#fff;color:#252525;font-family:inherit;font-size:15px;font-weight:600;line-height:1.4;white-space:normal;cursor:pointer;}'
          + '.stackhouse-color-profile-actions button:first-child{background:#252525;color:#fff;}'
          + '.stackhouse-color-profile-panel :focus-visible{outline:3px solid #1464c0;outline-offset:3px;}'
          + '@media(max-width:480px){[data-stackhouse-color-profile-dialog]{padding:16px;}.stackhouse-color-profile-panel{padding:22px;}}';
        document.body.appendChild(style);
      }

      dialog.setAttribute('data-stackhouse-color-profile-dialog', '');
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-labelledby', id + '-title');
      dialog.setAttribute('aria-describedby', id + '-message');
      panel.className = 'stackhouse-color-profile-panel';
      title.id = id + '-title';
      title.textContent = warning.warning_title || 'No color profile found';
      title.tabIndex = -1;
      name.className = 'stackhouse-color-profile-name';
      name.textContent = fileName || '';
      message.id = id + '-message';
      message.textContent = warning.warning;
      actions.className = 'stackhouse-color-profile-actions';
      continueButton.type = chooseButton.type = 'button';
      continueButton.textContent = 'Continue with this file';
      chooseButton.textContent = 'Choose another file';
      panel.appendChild(title);
      if (fileName) panel.appendChild(name);
      panel.appendChild(message);
      var focusable = [continueButton, chooseButton];
      try {
        var url = new window.URL(warning.warning_link || '');
        if (url.protocol === 'https:' && !url.username && !url.password) {
          var link = document.createElement('a');
          link.textContent = warning.warning_link_label || 'Learn about color profiles';
          link.href = url.href;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          panel.appendChild(link);
          focusable.unshift(link);
        }
      } catch (_error) { /* Missing and unsafe help destinations are omitted. */ }
      actions.appendChild(continueButton);
      actions.appendChild(chooseButton);
      panel.appendChild(actions);
      dialog.appendChild(panel);

      function finish(accepted) {
        if (finished) return;
        finished = true;
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        dialog.remove();
        if (previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus();
        resolve(accepted);
      }
      continueButton.addEventListener('click', function () { finish(true); });
      chooseButton.addEventListener('click', function () { finish(false); });
      dialog.addEventListener('cancel', function (event) { event.preventDefault(); finish(false); });
      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { event.preventDefault(); finish(false); return; }
        if (event.key !== 'Tab') return;
        var current = focusable.indexOf(document.activeElement);
        if (current === -1 || (event.shiftKey && current === 0) || (!event.shiftKey && current === focusable.length - 1)) {
          event.preventDefault();
          focusable[event.shiftKey ? focusable.length - 1 : 0].focus();
        }
      });
      document.body.appendChild(dialog);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else { dialog.setAttribute('data-fallback', ''); dialog.setAttribute('open', ''); }
      title.focus();
    });
  }

  function acknowledgeUploadWarning(value, options) {
    var warning = colorProfileWarning(value);
    if (!warning) return Promise.resolve(value);
    options = options || {};
    var image = value.image_object || {};
    var fileName = options.file && options.file.name || value.file_name || image.original_file_name || image.file_name || '';
    var review = warningQueue.then(function () { return showColorProfileWarning(warning, fileName); });
    // Concurrent uploads wait for their own review, including after a declined file.
    warningQueue = review.then(function () {}, function () {});
    return review.then(function (accepted) {
      if (accepted) return value;
      var error = uploadError('UPLOAD_SELECTION_CANCELLED', 'Choose another file when you are ready.');
      error.assetId = value.asset_id || '';
      throw error;
    });
  }

  function startsWithBytes(bytes, signature) {
    if (bytes.length < signature.length) return false;
    for (var index = 0; index < signature.length; index += 1) {
      if (bytes[index] !== signature[index]) return false;
    }
    return true;
  }

  function detectedFileFamily(bytes) {
    if (startsWithBytes(bytes, [0xFF, 0xD8, 0xFF])) return 'jpeg';
    if (startsWithBytes(bytes, [0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A])) return 'png';
    if (startsWithBytes(bytes, [0x49, 0x49, 0x2A, 0x00])) return 'tiff';
    if (startsWithBytes(bytes, [0x4D, 0x4D, 0x00, 0x2A])) return 'tiff';
    if (startsWithBytes(bytes, [0x49, 0x49, 0x2B, 0x00, 0x08, 0x00, 0x00, 0x00])) return 'tiff';
    if (startsWithBytes(bytes, [0x4D, 0x4D, 0x00, 0x2B, 0x00, 0x08, 0x00, 0x00])) return 'tiff';
    if (bytes.length >= 16 && String.fromCharCode.apply(null, bytes.slice(4, 8)) === 'ftyp') {
      var length = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength).getUint32(0);
      if (length >= 16 && length <= bytes.length && (length - 16) % 4 === 0) {
        var brands = [String.fromCharCode.apply(null, bytes.slice(8, 12))];
        for (var offset = 16; offset < length; offset += 4) brands.push(String.fromCharCode.apply(null, bytes.slice(offset, offset + 4)));
        if (!brands.some(function (brand) { return ['avif', 'avis', 'msf1'].indexOf(brand) !== -1; }) &&
            brands.some(function (brand) { return ['heic', 'heix', 'mif1'].indexOf(brand) !== -1; })) return 'heic';
      }
    }
    return '';
  }

  function claimedFileFamily(fileName) {
    var match = String(fileName || '').toLowerCase().match(/\.([a-z0-9]+)$/);
    var extension = match ? match[1] : '';
    if (extension === 'jpg' || extension === 'jpeg') return 'jpeg';
    if (extension === 'png') return 'png';
    if (extension === 'heic' || extension === 'heif') return 'heic';
    if (extension === 'tif' || extension === 'tiff') return 'tiff';
    return '';
  }

  function fileSignatureUnavailableError(reason) {
    var error = uploadError(
      'FILE_SIGNATURE_UNAVAILABLE',
      'We could not inspect this file. Choose it again, or refresh the page and try once more.'
    );
    error.uploadReadFailure = reason;
    return error;
  }

  function readBlobWithFileReader(blob) {
    if (typeof window.FileReader !== 'function') {
      return Promise.reject(fileSignatureUnavailableError('reader_unavailable'));
    }
    return new Promise(function (resolve, reject) {
      try {
        var reader = new window.FileReader();
        reader.onload = function () {
          if (reader.result === null || reader.result === undefined) {
            reject(fileSignatureUnavailableError('reader_empty'));
            return;
          }
          resolve(reader.result);
        };
        reader.onerror = function () {
          reject(fileSignatureUnavailableError('reader_error'));
        };
        reader.onabort = function () {
          reject(fileSignatureUnavailableError('reader_aborted'));
        };
        reader.readAsArrayBuffer(blob);
      } catch (_error) {
        reject(fileSignatureUnavailableError('reader_exception'));
      }
    });
  }

  function readFileHeader(file) {
    var blob;
    try {
      blob = file && typeof file.slice === 'function'
        ? file.slice(0, FILE_HEADER_BYTES)
        : null;
    } catch (_error) {
      blob = null;
    }

    if (!blob) {
      return Promise.reject(fileSignatureUnavailableError('blob_unavailable'));
    }
    if (typeof blob.arrayBuffer === 'function') {
      try {
        return Promise.resolve(blob.arrayBuffer()).catch(function () {
          return readBlobWithFileReader(blob);
        });
      } catch (_error) {
        return readBlobWithFileReader(blob);
      }
    }
    return readBlobWithFileReader(blob);
  }

  async function validateFileSignature(file) {
    var header;
    try {
      header = await readFileHeader(file);
    } catch (error) {
      if (error && error.errorCode) throw error;
      throw fileSignatureUnavailableError('reader_exception');
    }
    var detectedFamily = detectedFileFamily(new Uint8Array(header));
    var claimedFamily = claimedFileFamily(file && file.name);
    if (!detectedFamily || !claimedFamily || detectedFamily !== claimedFamily) {
      throw uploadError('UNSUPPORTED_FORMAT', UNSUPPORTED_FORMAT_MESSAGE);
    }
    return detectedFamily;
  }

  function wait(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function uploadRequestId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
      var value = Math.floor(Math.random() * 16);
      return (character === 'x' ? value : (value & 3) | 8).toString(16);
    });
  }

  function requestJson(url, options, timeoutMs, operation, correlation) {
    var requestId = operation ? uploadRequestId() : '';
    var started = Date.now();
    if (operation) {
      options = Object.assign({}, options, {
        headers: Object.assign({}, options.headers, { 'X-Requested-With': requestId })
      });
    }
    function trace(event, status, statusCode, error) {
      if (!operation) return;
      if (correlation && correlation.quiet && status !== 'failed') return;
      if (status === 'failed' && ((statusCode >= 400 && statusCode < 500)
        || (window.navigator && window.navigator.onLine === false)
        || (error && error.name === 'AbortError'))) status = 'abandoned';
      try {
        var telemetry = window.StackhouseOperationalTelemetry;
        if (telemetry && typeof telemetry.emit === 'function') telemetry.emit({
          workflow: 'upload_request_trace', stage: operation, event: event,
          status: status, severity: status === 'failed' ? 'warning' : 'info',
          attempt_id: requestId, workflow_instance_id: correlation && correlation.assetId,
          operation: operation, status_code: statusCode,
          retry_count: correlation && correlation.retryCount,
          duration_ms: Math.max(0, Date.now() - started),
          safe_message: 'Upload metadata request ' + status + '.',
          safe_context: { endpoint_family: 'uploads_api', endpoint_operation: operation, operation: operation,
            request_id: requestId, response_status: statusCode }
        });
      } catch (_error) {}
    }
    if (operation && correlation && correlation.attemptId && !correlation.quiet) {
      try {
        var telemetry = window.StackhouseOperationalTelemetry;
        if (telemetry && typeof telemetry.emit === 'function') telemetry.emit({
          workflow: 'upload_request_trace', stage: operation, operation: operation,
          event: 'upload_request_linked', status: 'succeeded',
          workflow_instance_id: correlation.assetId, attempt_id: correlation.attemptId,
          safe_context: { request_id: requestId, operation: operation }
        });
      } catch (_traceError) {}
    }
    trace('upload_request_started', 'started');
    var responseStatus;
    var controller = new AbortController();
    var timer;
    var deadline = new Promise(function (_resolve, reject) {
      timer = window.setTimeout(function () {
        var error = uploadError('UPLOAD_REQUEST_TIMEOUT', 'The upload request took too long. Please retry.');
        error.retryable = true;
        reject(error);
        controller.abort();
      }, timeoutMs || 20000);
    });
    var request = Promise.resolve().then(function () {
      return (window.stackhouseCustomerFetch || fetch)(url, Object.assign({}, options, { signal: controller.signal }));
    }).then(function (response) {
      responseStatus = response.status;
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) {
          var error = new Error(data.error || data.detail || 'The upload request failed.');
          error.statusCode = response.status;
          error.errorCode = data.error_code || data.error_type || '';
          error.retryable = data.retryable === undefined ? response.status >= 500 || response.status === 408 : Boolean(data.retryable);
          error.helpLink = data.help_link || data.support_link || '';
          error.responseData = data;
          error.retryAfterSeconds = Number(data.retry_after_seconds || data.quota && data.quota.retry_after_seconds || 0);
          error.nextSlotAt = data.next_slot_at || data.quota && data.quota.next_slot_at || '';
          throw error;
        }
        return data;
      });
    });
    // Race the complete body read as well as the response headers. Late results
    // cannot mutate upload state after the caller has received a timeout.
    return Promise.race([request, deadline]).then(function (data) {
      trace('upload_request_completed', 'succeeded', responseStatus);
      return data;
    }, function (error) {
      if (operation) {
        trace('upload_request_failed', 'failed', error && error.statusCode, error);
        try {
          error.uploadRequestOperation = operation;
          error.uploadRequestId = requestId;
        } catch (_error) {}
      }
      throw error;
    }).finally(function () { window.clearTimeout(timer); });
  }

  function canRecoverFinalization(error) {
    if (!error || error.retryable === false || error.name === 'AbortError'
      || (window.navigator && window.navigator.onLine === false)) return false;
    return error.name === 'TypeError' || error.errorCode === 'UPLOAD_REQUEST_TIMEOUT'
      || error.statusCode === 408 || error.statusCode === 429 || error.statusCode >= 500;
  }

  async function finalizeAsset(apiBaseUrl, asset, parts, eventDetails) {
    var details = eventDetails || {};
    var correlation = {
      assetId: asset.asset_id,
      attemptId: details.upload_attempt_id || details.attempt_id || ''
    };
    for (var attempt = 0; attempt < 2; attempt += 1) {
      try {
        return await requestJson(apiBaseUrl + '/api/uploads/v2/assets/' + asset.asset_id + '/complete/', {
          method: 'POST', headers: accessHeaders(), body: JSON.stringify({ parts: parts })
        }, 60000, 'asset_finalize', correlation);
      } catch (error) {
        if (!canRecoverFinalization(error)) throw error;
        await wait(500);
        var current;
        try {
          current = await requestJson(apiBaseUrl + '/api/uploads/v2/assets/' + asset.asset_id + '/', {
            method: 'GET', headers: accessHeaders()
          }, 20000, 'asset_status', correlation);
        } catch (_statusError) { throw error; }
        if (!current || current.asset_id !== asset.asset_id) throw error;
        if (current.status === 'ready' || current.status === 'processing') return current;
        // Completion is idempotent for this asset. Never re-upload bytes, create
        // another asset, or replay processing after an ambiguous response.
        if (attempt || current.status !== 'uploading') throw error;
      }
    }
  }

  function accessHeaders() {
    var headers = typeof window.stackhouseCustomerAccessHeaders === 'function'
      ? window.stackhouseCustomerAccessHeaders({ 'Content-Type': 'application/json' })
      : { 'Content-Type': 'application/json' };
    if (guestToken) headers['X-Stackhouse-Upload-Token'] = guestToken;
    return headers;
  }

  function abortTransferOnPageHide() {
    Object.keys(activeTransfers).forEach(function (assetId) {
      var transfer = activeTransfers[assetId];
      fetch(transfer.apiBaseUrl + '/api/uploads/v2/assets/' + assetId + '/', {
        method: 'DELETE',
        headers: accessHeaders(),
        keepalive: true
      }).catch(function () {});
    });
  }

  function trackActiveTransfer(apiBaseUrl, assetId) {
    activeTransfers[assetId] = { apiBaseUrl: apiBaseUrl };
    if (!pagehideCleanupBound && typeof window.addEventListener === 'function') {
      pagehideCleanupBound = true;
      window.addEventListener('pagehide', abortTransferOnPageHide);
    }
  }

  function forgetActiveTransfer(assetId) {
    if (assetId) delete activeTransfers[assetId];
  }

  function heartbeatUpload(apiBaseUrl, assetId) {
    return requestJson(apiBaseUrl + '/api/uploads/v2/assets/' + assetId + '/heartbeat/', {
      method: 'POST',
      headers: accessHeaders(),
      body: '{}'
    }).catch(function () { return null; });
  }

  function rememberGuestToken(token) {
    guestToken = token || '';
    try {
      if (guestToken) window.localStorage.setItem(GUEST_STORAGE_KEY, guestToken);
      else window.localStorage.removeItem(GUEST_STORAGE_KEY);
    } catch (_error) { /* The current tab retains access when storage is unavailable. */ }
  }

  function unifiedAvailable() {
    var policy = window.StackhouseUploadPolicy;
    if (!policy || typeof policy.ready !== 'function') return Promise.resolve(false);
    return policy.ready().then(function (value) { return value.transport === 'upload_v2' && value.guest_uploads === true; });
  }

  function customerAccessReady() {
    var access = window.STACKHOUSE_CUSTOMER_ACCESS || {};
    return Boolean(access.id && access.email && access.token && access.timestamp);
  }

  function clientUploadId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'upload-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  async function createSession(apiBaseUrl, uploadSurface) {
    var unified = await unifiedAvailable();
    var surface = String(uploadSurface || '').slice(0, 24);
    var owner = customerAccessReady() ? String(window.STACKHOUSE_CUSTOMER_ACCESS.id) : 'guest';
    var key = apiBaseUrl + '|' + owner + '|' + (unified ? 'all' : surface);
    if (key !== sessionSurface) sessionPromise = null;
    sessionSurface = key;
    if (!customerAccessReady() && !unified) {
      throw uploadError('CUSTOMER_AUTH_REQUIRED', 'Sign in to use the large-image upload beta.');
    }
    if (!sessionPromise) {
      async function requestSession(renewed) {
        try {
          var session = await requestJson(apiBaseUrl + '/api/uploads/v2/sessions/', {
            method: 'POST', headers: accessHeaders(),
            body: JSON.stringify({ upload_surface: surface })
          }, undefined, 'session_create');
          if (session.guest_token) rememberGuestToken(session.guest_token);
          return session;
        } catch (error) {
          if (!renewed && owner === 'guest' && error.errorCode === 'GUEST_SESSION_INVALID') {
            rememberGuestToken('');
            return requestSession(true);
          }
          throw error;
        }
      }
      function beginSession() {
        if (owner === 'guest') {
          try { guestToken = window.localStorage.getItem(GUEST_STORAGE_KEY) || guestToken; } catch (_error) {}
        }
        return requestSession(false);
      }
      var locks = window.navigator && window.navigator.locks;
      sessionPromise = (owner === 'guest' && locks ? locks.request('stackhouse-guest-upload-session', beginSession) : beginSession())
        .catch(function (error) { sessionPromise = null; throw error; });
    }
    return sessionPromise;
  }

  function prepare(options) {
    var apiBaseUrl = String(options && options.apiBaseUrl || '').replace(/\/$/, '');
    return createSession(apiBaseUrl, options && options.uploadSurface);
  }

  function abortUpload(apiBaseUrl, assetId) {
    return requestJson(apiBaseUrl + '/api/uploads/v2/assets/' + assetId + '/', {
      method: 'DELETE',
      headers: accessHeaders()
    }, 2000).catch(function () {
      return null;
    });
  }

  function serverPlan(file, asset, resilience) {
    return resilience.createPlan(file, {
      multipartThresholdBytes: 0,
      partSizeBytes: asset.part_size_bytes
    });
  }

  function pollUntilReady(apiBaseUrl, assetId, options) {
    var startedAt = Date.now();
    var pollCount = 0;
    var timeoutMs = PROCESSING_TIMEOUT_MS;
    var statusRetries = 0;

    function expired() {
      var error = uploadError('UPLOAD_PROCESSING_TIMEOUT', 'Your upload is safe, but preview processing took too long. Try processing again.');
      error.retryable = true;
      error.assetId = assetId;
      error.uploadFailurePhase = 'processing';
      return error;
    }

    function retryStatus(error) {
      if (!error || error.retryable === false || error.name === 'AbortError') throw error;
      var status = Number(error.statusCode || 0);
      var transient = error.name === 'TypeError' || error.errorCode === 'UPLOAD_REQUEST_TIMEOUT'
        || status === 408 || status === 429 || status >= 500;
      if (!transient || statusRetries >= STATUS_READ_RETRY_DELAYS.length) throw error;
      var remaining = timeoutMs - (Date.now() - startedAt);
      if (remaining <= 0) throw expired();
      var retryAfter = Number(error.retryAfterSeconds || 0) * 1000;
      var delay = Math.min(Math.max(STATUS_READ_RETRY_DELAYS[statusRetries],
        Number.isFinite(retryAfter) && retryAfter > 0 ? retryAfter : 0), remaining);
      statusRetries += 1;
      return wait(delay).then(poll);
    }

    function poll() {
      if (Date.now() - startedAt >= timeoutMs) {
        return Promise.reject(expired());
      }
      return requestJson(apiBaseUrl + '/api/uploads/v2/assets/' + assetId + '/', {
        method: 'GET',
        headers: accessHeaders()
      }, Math.max(1, Math.min(20000, timeoutMs - (Date.now() - startedAt))), 'asset_status', {
        assetId: assetId, quiet: true, retryCount: statusRetries
      }).then(function (asset) {
        if (Date.now() - startedAt >= timeoutMs) throw expired();
        if (asset.status === 'ready') {
          if (statusRetries) {
            try {
              var telemetry = window.StackhouseOperationalTelemetry;
              if (telemetry && typeof telemetry.emit === 'function') telemetry.emit({
                workflow: 'upload_request_trace', stage: 'asset_status', operation: 'asset_status',
                event: 'upload_status_read_recovered', status: 'succeeded',
                workflow_instance_id: assetId, retry_count: statusRetries,
                safe_context: { operation: 'asset_status', retry_count: statusRetries }
              });
            } catch (_traceError) {}
          }
          return asset;
        }
        if (asset.status === 'aborted') {
          var unavailable = uploadError('ASSET_NOT_UPLOADING', 'This upload is no longer available. Choose the file again.');
          unavailable.assetId = assetId;
          unavailable.uploadFailurePhase = 'processing';
          throw unavailable;
        }
        if (asset.status === 'failed') {
          var error = new Error(asset.error || 'The uploaded image could not be prepared.');
          error.errorCode = asset.error_code || 'UPLOAD_PROCESSING_FAILED';
          error.retryable = Boolean(asset.retryable);
          error.helpLink = asset.help_link || asset.support_link || '';
          error.assetId = asset.asset_id || assetId;
          error.uploadFailurePhase = 'processing';
          throw error;
        }
        timeoutMs = asset.preparation ? PREPARATION_TIMEOUT_MS : PROCESSING_TIMEOUT_MS;
        if (Date.now() - startedAt >= timeoutMs) {
          throw expired();
        }
        pollCount += 1;
        if (typeof options.onProcessing === 'function') {
          options.onProcessing(asset);
        }
        return wait(pollCount < 10 ? 1000 : 2000).then(poll);
      }, retryStatus);
    }

    return poll();
  }

  async function upload(options) {
    var apiBaseUrl = String(options.apiBaseUrl || '').replace(/\/$/, '');
    var file = options.file;
    var resilience = window.StackhouseUploadResilience;
    var owner = String((window.STACKHOUSE_CUSTOMER_ACCESS || {}).id || 'guest');
    var key = apiBaseUrl + '|' + owner + '|' + String(options.uploadSurface || '');
    var recovery = recoveries.get(file);
    if (!recovery || recovery.key !== key) {
      recovery = { key: key, clientId: clientUploadId() };
      recoveries.set(file, recovery);
    }
    var asset = recovery.asset || null;
    var transferFinalized = false;
    var finalizationStarted = Boolean(recovery.parts);
    var lastHeartbeatAt = 0;
    var heartbeatIntervalMs = 60 * 1000;

    if (!resilience || typeof resilience.upload !== 'function') {
      throw new Error('The uploader could not start. Refresh the page and try again.');
    }

    if (window.StackhouseUploadPolicy && typeof window.StackhouseUploadPolicy.validateFile === 'function') {
      var validation = await window.StackhouseUploadPolicy.validateFile(file);
      if (!validation.valid) {
        var validationError = uploadError(validation.error_code || 'UNSUPPORTED_FORMAT', validation.error);
        validationError.helpLink = validation.help_link || '';
        throw validationError;
      }
    }
    await validateFileSignature(file);

    if (typeof options.onStage === 'function') {
      options.onStage('session');
    }
    try {
      var session = recovery.session || await createSession(apiBaseUrl, options.uploadSurface);
      recovery.session = session;
      var policy = session.policy || {};
      if (typeof options.onPolicy === 'function') options.onPolicy(policy);
      var registrationDeadline = 0;
      var admissionRetries = 0;
      var registrationError;
      async function createAsset() {
        if (!registrationDeadline) registrationDeadline = Date.now() + 20000;
        for (;;) {
          var remaining = registrationDeadline - Date.now();
          if (remaining <= 0) throw registrationError;
          try { return await requestJson(
        apiBaseUrl + '/api/uploads/v2/sessions/' + session.session_id + '/assets/',
        {
          method: 'POST',
          headers: accessHeaders(),
          body: JSON.stringify({
            client_upload_id: recovery.clientId,
            file_name: file.name,
            file_type: file.type || 'application/octet-stream',
            file_size: file.size,
            upload_surface: String(options.uploadSurface || '').slice(0, 24),
            upload_policy_version: policy.policy_version || ''
          })
        }, remaining, 'asset_create', { retryCount: admissionRetries }
          ); } catch (error) {
            registrationError = error;
            if (error.errorCode !== 'UPLOAD_ADMISSION_BUSY' || error.statusCode !== 503
              || error.retryable !== true || admissionRetries >= ADMISSION_RETRY_DELAYS.length) throw error;
            remaining = registrationDeadline - Date.now();
            var retryAfter = Number(error.retryAfterSeconds || 0) * 1000;
            var delay = Math.max(ADMISSION_RETRY_DELAYS[admissionRetries],
              Number.isFinite(retryAfter) && retryAfter > 0 ? retryAfter : 0);
            if (delay >= remaining) throw error;
            admissionRetries += 1;
            await wait(delay);
          }
        }
      }
      if (asset) {
        asset = await requestJson(apiBaseUrl + '/api/uploads/v2/assets/' + asset.asset_id + '/', { method: 'GET', headers: accessHeaders() }, undefined, 'asset_status', { assetId: asset.asset_id, quiet: true });
        if (asset.status === 'aborted') {
          recoveries.delete(file);
          return upload(options);
        }
      }
      try { if (!asset) asset = await createAsset(); } catch (error) {
        if (error.errorCode !== 'SESSION_EXPIRED') throw error;
        sessionPromise = null;
        session = await createSession(apiBaseUrl, options.uploadSurface);
        recovery.session = session;
        policy = session.policy || {};
        asset = await createAsset();
      }
      recovery.asset = asset;
      if (asset.status === 'ready' || asset.status === 'processing' || asset.status === 'failed') {
        transferFinalized = true;
        forgetActiveTransfer(asset.asset_id);
        if (asset.status === 'failed') return await retryStoredProcessing(Object.assign({}, options, { assetId: asset.asset_id }));
        var existing = asset.status === 'ready' ? asset : await pollUntilReady(apiBaseUrl, asset.asset_id, options);
        return await acknowledgeUploadWarning(existing, options);
      }
      if (asset.status !== 'uploading') throw uploadError('ASSET_NOT_UPLOADING', 'This upload is no longer available. Choose the file again.');
      if (!recovery.parts) {
        trackActiveTransfer(apiBaseUrl, asset.asset_id);
        lastHeartbeatAt = Date.now();
        if (asset.active_lease && asset.active_lease.heartbeat_interval_seconds) {
          heartbeatIntervalMs = Math.max(15 * 1000, Number(asset.active_lease.heartbeat_interval_seconds) * 1000);
        }
        var plan = serverPlan(file, asset, resilience);
        var partNumbers = [];
        for (var partNumber = 1; partNumber <= asset.total_parts; partNumber += 1) {
          partNumbers.push(partNumber);
        }
        var signedParts = await requestJson(
          apiBaseUrl + '/api/uploads/v2/assets/' + asset.asset_id + '/parts/',
          {
            method: 'POST',
            headers: accessHeaders(),
            body: JSON.stringify({ part_numbers: partNumbers })
          }, undefined, 'asset_parts', { assetId: asset.asset_id }
        );

        if (typeof options.onStage === 'function') {
          options.onStage('transfer', asset);
        }
        var uploadResult;
        try { uploadResult = await resilience.upload({
          file: file,
          urls: signedParts.preSignedUrls,
          plan: plan,
          eventDetails: Object.assign({
            source: 'beta_order_builder_upload_v2',
            upload_asset_id: asset.asset_id
          }, options.eventDetails || {}),
          onActivity: function () {
            if (Date.now() - lastHeartbeatAt >= heartbeatIntervalMs) {
              lastHeartbeatAt = Date.now();
              heartbeatUpload(apiBaseUrl, asset.asset_id);
            }
          },
          onProgress: function (percent) {
            if (typeof options.onProgress === 'function') options.onProgress(percent);
          },
          onRetry: options.onRetry
        }); } catch (transferError) {
          transferError.uploadRequestOperation = 'asset_transfer';
          throw transferError;
        }

        recovery.parts = uploadResult.parts;
      }
      finalizationStarted = true;
      // Completion may commit after a lost response. Never DELETE it on pagehide.
      forgetActiveTransfer(asset.asset_id);
      if (typeof options.onStage === 'function') {
        options.onStage('finalization', asset);
      }
      var complete = await finalizeAsset(apiBaseUrl, asset, recovery.parts, options.eventDetails);
      transferFinalized = true;
      forgetActiveTransfer(asset.asset_id);
      if (complete.status === 'ready') {
        return await acknowledgeUploadWarning(complete, options);
      }
      if (typeof options.onStage === 'function') {
        options.onStage('processing', complete);
      }
      return await pollUntilReady(apiBaseUrl, asset.asset_id, options).then(function (ready) {
        return acknowledgeUploadWarning(ready, options);
      });
    } catch (error) {
      if (error && error.uploadRequestId) {
        try {
          var details = options.eventDetails || {};
          var attemptId = details.upload_attempt_id || details.attempt_id || uploadRequestId();
          var telemetry = window.StackhouseOperationalTelemetry;
          if (telemetry && typeof telemetry.emit === 'function') telemetry.emit({
            workflow: 'upload_request_trace', stage: error.uploadRequestOperation,
            event: 'upload_request_linked', status: 'succeeded',
            workflow_instance_id: details.workflow_instance_id || attemptId, attempt_id: attemptId,
            safe_context: { request_id: error.uploadRequestId, endpoint_operation: error.uploadRequestOperation, operation: error.uploadRequestOperation }
          });
        } catch (_traceError) {}
      }
      if (asset && !transferFinalized && !finalizationStarted) {
        var aborted = await abortUpload(apiBaseUrl, asset.asset_id);
        if (aborted) recoveries.delete(file);
      }
      if (asset) error.assetId = error.assetId || asset.asset_id;
      if (asset && finalizationStarted && error.retryable !== false && error.name !== 'AbortError') {
        error.retryable = true;
        error.assetId = asset.asset_id;
      }
      forgetActiveTransfer(asset && asset.asset_id);
      throw error;
    }
  }

  function retryProcessing(options) {
    if (options.file && recoveries.has(options.file)) return upload(options);
    return retryStoredProcessing(options);
  }

  function retryStoredProcessing(options) {
    var apiBaseUrl = String(options.apiBaseUrl || '').replace(/\/$/, '');
    return requestJson(
      apiBaseUrl + '/api/uploads/v2/assets/' + options.assetId + '/retry-processing/',
      {
        method: 'POST',
        headers: accessHeaders(),
        body: '{}'
      }, undefined, 'asset_retry_processing', { assetId: options.assetId }
    ).then(function (asset) {
      if (typeof options.onProcessing === 'function') {
        options.onProcessing(asset);
      }
      var ready = asset.status === 'ready' ? Promise.resolve(asset) : pollUntilReady(apiBaseUrl, options.assetId, options);
      return ready.then(function (result) { return acknowledgeUploadWarning(result, options); });
    });
  }

  function processingMessage(asset) {
    return asset && asset.preparation && asset.preparation.status !== 'ready'
      ? 'Preparing your photo for printing. Your original is unchanged.'
      : 'Upload complete. Preparing your preview.';
  }

  async function uploadForInterface(options) {
    var report = typeof options.onStatus === 'function' ? options.onStatus : function () {};
    var settings = Object.assign({}, options, {
      onStage: function (stage) { report(stage === 'processing' ? 'Upload complete. Preparing your preview.' : 'Preparing secure upload.', stage === 'processing' ? 100 : 1); },
      onProgress: function (percent) { report('Uploading file, ' + percent + '%.', percent); },
      onRetry: function (_part, attempt) { report('Connection interrupted. Retrying upload (' + attempt + '/3)...'); },
      onProcessing: function (asset) { report(processingMessage(asset), 100); }
    });
    var result;
    try { result = await upload(settings); } catch (error) {
      if (!error.retryable || !error.assetId || error.name === 'AbortError'
        || error.uploadRequestOperation === 'asset_status' || error.errorCode === 'UPLOAD_PROCESSING_TIMEOUT') throw error;
      report('Retrying preview preparation.', 100);
      result = await retryProcessing(Object.assign({}, settings, { assetId: error.assetId }));
    }
    if (!result.image_object || !result.image_object.order) throw new Error('Your preview is not ready. Please try again.');
    return result.image_object;
  }

  window.StackhouseUploadV2 = Object.freeze({
    acknowledgeUploadWarning: acknowledgeUploadWarning,
    isSelectionCancelled: isSelectionCancelled,
    discardUploadPreview: discardUploadPreview,
    prepare: prepare,
    unifiedAvailable: unifiedAvailable,
    uploadForInterface: uploadForInterface,
    processingMessage: processingMessage,
    guestToken: function () { return guestToken; },
    upload: upload,
    retryProcessing: retryProcessing,
    customerAccessReady: customerAccessReady,
    validateFileSignature: validateFileSignature
  });
})(window);
